export default {
    apiUrl:window.appURL,
    basename:window.Basename
};


// WEBPACK FOOTER //
// ./src/core/Config.js